import VendorsFancybox from './fancybox';

const index = () => {
	/* eslint-disable no-console */
	// if (processEnv === 'development') {
	// 	console.log('Vendors');
	// }
	/* eslint-enable no-console */
	VendorsFancybox();
};

export default index;
